import React, { useState, useEffect } from 'react'
import {
  Form,
  Pagination,
  Button,
  Modal,
  Container,
  FormGroup,
  FormLabel,
  FormSelect,
} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import toast from 'react-hot-toast'
import Cookies from 'js-cookie'
import axios from 'axios'
import { ChatDots } from 'react-bootstrap-icons'

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { FaEye, FaEyeSlash } from 'react-icons/fa'

const Marketer = () => {
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '270px' : '0px',
  )
  const [showEditModal, setShowEditModal] = useState(false)
  const [selectedEnquiry, setSelectedEnquiry] = useState(null)

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const initialData = []

  const [user, setUser] = useState(null)

  const [data, setData] = useState(initialData)
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [showModal, setShowModal] = useState(false)

  const [newMarketer, setNewMarketer] = useState({
    name: '',
    email: '',
    phone: '',
    status: '',
    dob: '',
    gender: '',
    address: '',
    qualification: '',
    institute_id: '',
    joining_date: '',
    password: '',
  })

  const [courses, setCourses] = useState([])
  const [institutes, setInstitutes] = useState([])

  useEffect(() => {
    ApiEndpoints.getAllCourses().then((res) => setCourses(res.data.data))
    ApiEndpoints.getAllInstitutes().then((res) => setInstitutes(res.data.data))
  }, [])

  // Filter Data Based on Search
  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      value !== null && value !== undefined
        ? value.toString().toLowerCase().includes(search.trim().toLowerCase())
        : false,
    ),
  )

  // Pagination Logic
  const totalPages = Math.ceil(filteredData.length / itemsPerPage)
  useEffect(() => {
    if (currentPage > totalPages && totalPages !== 0) {
      setCurrentPage(1)
    }
  }, [filteredData, totalPages])

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem)

  // Handle Form Input
  const handleInputChange = (e) => {
    const { name, value } = e.target
    console.log(
      `Input Changed - Name: ${name}, Value: ${value} (Type: ${typeof value})`,
    )
    setNewMarketer((prev) => ({ ...prev, [name]: value }))
  }

  const handleSave = async () => {
    const userLogged = Cookies.get('user')
    console.log('Checking if user is logged in:', userLogged)
    if (userLogged) {
      try {
        const parsedUser = JSON.parse(userLogged)
        console.log('Sending data: ', newMarketer)
        const token = parsedUser?.token
        // const enquiry_taken_by = parsedUser?.name || parsedUser?.user_id
        // console.log('enquiry_taken_by', enquiry_taken_by)

        const marketerPayload = {
          ...newMarketer,
        }

        const response = await ApiEndpoints.addMarketer(marketerPayload, token)
        setNewMarketer('Response: ', response)
        // setData(response.data)
        // Reset the form after submission
        setNewMarketer({
          name: '',
          email: '',
          phone: '',
          status: '',
          dob: '',
          gender: '',
          address: '',
          qualification: '',
          institute_id: '',
          joining_date: '',
          password: '',
        })
        setShowModal(false)

        toast.success(response.data.message)
      } catch (error) {
        toast.error(error.response?.data?.message)
      }
    }
  }
  const [showPassword, setShowPassword] = useState(false)
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  return (
    <div style={{ marginLeft }}>
      <div
        className="container-fluid p-0"
        style={{
          marginTop: window.innerWidth < 768 ? '55px' : '-11px',
        }}
      >
        <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white mt-md-0 mt-5">
          <h2 className="m-0">Marketers</h2>
          <Button
            variant="light"
            className="fw-bold px-4 py-2 rounded shadow-sm d-flex align-items-center"
            onClick={() => setShowModal(true)}
          >
            <ChatDots size={18} className="me-2" />
            Add Marketer
          </Button>
        </div>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-3 mt-4 container">
        <Form.Control
          type="text"
          placeholder="Search Student Name"
          className="w-25"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <Form.Select
          className="w-auto"
          value={itemsPerPage}
          onChange={(e) => {
            setItemsPerPage(parseInt(e.target.value))
            setCurrentPage(1)
          }}
        >
          <option value="10">10 per page</option>
          <option value="20">20 per page</option>
          <option value="30">30 per page</option>
        </Form.Select>
      </div>

      <Container className="table-responsive">
        <Table className="table table-striped table-bordered table-hover rounded overflow-hidden shadow-sm mb-0">
          <Thead className="bg-dark text-white">
            <Tr>
              <Th>Student Name</Th>
              <Th>Phone</Th>
              <Th>Message</Th>
              <Th>Enquiry By</Th>
              <Th>Status</Th>
              <Th>Action</Th>
            </Tr>
          </Thead>
          <Tbody>
            {/* {currentItems.length > 0 ? (
              currentItems.map((item, index) => (
                <Tr key={index} className="align-middle">
                  <Td>{item.name}</Td>
                  <Td>{item.phone}</Td>
                  <Td>{item.message}</Td>
                  <Td>{item.enquiry_by}</Td>
                  <Td>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                      }}
                    >
                      <select
                        className={`form-select btn btn-sm ${
                          item.status === 'complete'
                            ? 'btn-success'
                            : 'btn-warning'
                        }`}
                        value={item.status}
                        onChange={(e) =>
                          handleStatusChange(item.id, e.target.value)
                        }
                      >
                        <option value="pending">Pending</option>
                        <option value="complete">Complete</option>
                      </select>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() =>
                          console.log('Submit status for item', item.id)
                        }
                      >
                        Submit
                      </button>
                    </div>
                  </Td>

                  <Td className="text-center">
                    <div className="d-flex flex-wrap justify-content-start justify-content-md-center gap-2">
                      <Button
                        variant="warning"
                        className="d-flex flex-wrap justify-content-center align-items-center gap-2"
                        onClick={() => {
                          setSelectedEnquiry(item)
                          setShowEditModal(true)
                        }}
                      >
                        <PencilSquare />
                      </Button>
                    </div>
                  </Td>
                </Tr>
              ))
            ) : (
              <Tr>
                <Td colSpan="9" className="text-center text-muted fw-bold p-4">
                  No records found
                </Td>
              </Tr>
            )} */}
          </Tbody>
        </Table>
      </Container>

      <div className="d-flex justify-content-between align-items-center">
        <p className="text-black ms-2">
          Total Marketers: {filteredData.length}
        </p>
        <Pagination className="mt-2">
          <Pagination.Prev
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          />
          {[...Array(totalPages)].map((_, i) => (
            <Pagination.Item
              key={i}
              active={i + 1 === currentPage}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>

      {/* Add New Class Modal */}
      <Modal
        size="lg"
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
      >
        <Modal.Header closeButton className="text-white bg-secondary">
          <Modal.Title>Add New Marketer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSave}>
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={newMarketer.name}
                onChange={handleInputChange}
                placeholder="Enter name"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Date of Birth</Form.Label>
              <Form.Control
                type="date"
                name="dob"
                value={newMarketer.dob}
                onChange={handleInputChange}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Gender</Form.Label>

              <div>
                <Form.Check
                  inline
                  type="radio"
                  name="gender"
                  label="Male"
                  value="Male"
                  checked={newMarketer.gender === 'Male'}
                  onChange={handleInputChange}
                  required
                />
                <Form.Check
                  inline
                  type="radio"
                  name="gender"
                  label="Female"
                  value="Female"
                  checked={newMarketer.gender === 'Female'}
                  onChange={handleInputChange}
                  required
                />
                <Form.Check
                  inline
                  type="radio"
                  name="gender"
                  label="Other"
                  value="Other"
                  checked={newMarketer.gender === 'Other'}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                type="tel"
                name="phone"
                value={newMarketer.phone}
                onChange={handleInputChange}
                placeholder="Enter phone number"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={newMarketer.email}
                onChange={handleInputChange}
                placeholder="Enter email"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Password *</Form.Label>
              <div className="input-group">
                <Form.Control
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={newMarketer.password}
                  onChange={handleInputChange}
                  placeholder="Enter Password"
                  className="p-2 border rounded"
                  required
                />
                <Button
                  variant="outline-secondary"
                  onClick={togglePasswordVisibility}
                  title={showPassword ? 'Hide Password' : 'Show Password'}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </Button>
              </div>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Date of Join</Form.Label>
              <Form.Control
                type="date"
                name="joining_date"
                value={newMarketer.joining_date}
                onChange={handleInputChange}
                className="p-2 border rounded"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Address</Form.Label>
              <Form.Control
                as="textarea"
                name="address"
                value={newMarketer.address}
                onChange={handleInputChange}
                placeholder="Enter address"
                required
                rows={3}
              />
            </Form.Group>
            {/* Description */}
            {/* <Form.Group className="mb-3">
              <Form.Label>Parent's Number</Form.Label>
              <Form.Control
                type="tel"
                name="parents_number"
                value={newMarketer.parents_number}
                onChange={handleInputChange}
                placeholder="Enter parent's phone number"
              />
            </Form.Group> */}
            <FormGroup className="mb-3">
              <FormLabel>Institute *</FormLabel>
              <FormSelect
                name="institute_id"
                value={newMarketer.institute_id}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Institute</option>
                {institutes.map((institute) => (
                  <option key={institute.id} value={institute.institute_id}>
                    {institute.name}
                  </option>
                ))}
              </FormSelect>
            </FormGroup>
            <Form.Group className="mb-3">
              <Form.Label>qualification</Form.Label>
              <Form.Control
                as="textarea"
                name="qualification"
                value={newMarketer.qualification}
                onChange={handleInputChange}
                placeholder="Enter qualification"
                rows={3}
                required
              />
            </Form.Group>
            <Modal.Footer>
              <Button
                variant="danger"
                className="rounded-pill px-4"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </Button>
              <Button
                variant="success"
                className="rounded-pill px-4"
                type="submit"
              >
                Save Marketer
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
      {/* <EditMarketer
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        enquiry={selectedEnquiry}
      /> */}
    </div>
  )
}

export default Marketer
